import { render } from "./widget.vue?vue&type=template&id=7a8148d0&scoped=true"
import script from "./widget.vue?vue&type=script&lang=js"
export * from "./widget.vue?vue&type=script&lang=js"

import "./widget.vue?vue&type=style&index=0&id=7a8148d0&scoped=true&lang=css"
import "./widget.vue?vue&type=style&index=1&id=7a8148d0&lang=css"

import exportComponent from "D:\\Users\\User\\Documents\\_PROJECTS\\VUE.JS\\tulmash\\web_widgets\\calc_conveyor\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8148d0"]])

export default __exports__